// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"sJ-z","carouselContainer":"tJ-z"};